namespace TabAurous.Inventory {
    export interface LotCreationItemsForm {
        PartyId: Serenity.IntegerEditor;
        TransItemId: Serenity.StringEditor;
        BagNo: Serenity.StringEditor;
        SKU: Serenity.StringEditor;
        LotNo: Serenity.StringEditor;
        CertificateNo: Serenity.StringEditor;
        RefNo: Serenity.StringEditor;
        ItemTypeId: Serenity.IntegerEditor;
        ProductId: Serenity.StringEditor;
        DesignId: Serenity.StringEditor;
        ProductCode: Serenity.StringEditor;
        ProductName: Serenity.StringEditor;
        DesignCode: Serenity.StringEditor;
        AttributeId: Serenity.StringEditor;
        ProductTypeId: Serenity.LookupEditor;
        CategoryId: CommonCategoryLookup;
        SubCategoryId: CommonSubCategoryLookup;
        BrandId: Serenity.LookupEditor;
        SuperTypeId: Serenity.LookupEditor;
        CollectionId: Serenity.LookupEditor;
        Pieces: Serenity.IntegerEditor;
        Weight: WeightEditor;
        UnitRate: Serenity.DecimalEditor;
        StoneRate: AmountEditor;
        OtherRate: AmountEditor;
        UnitLabour: Serenity.DecimalEditor;
        FancyCharges: AmountEditor;
        OtherCharges: AmountEditor;
        StoneAmount: Serenity.DecimalEditor;
        NetAmount: Serenity.DecimalEditor;
        GrossAmount: Serenity.DecimalEditor;
        CCNetAmount: Serenity.DecimalEditor;
        CCGrossAmount: Serenity.DecimalEditor;
        HasBom: Serenity.BooleanEditor;
        Line_No: Serenity.StringEditor;
        HSN: Serenity.LookupEditor;
        NetWeight: WeightEditor;
        DiamondPieces: Serenity.IntegerEditor;
        DiamondWeight: WeightEditor;
        StonePieces: Serenity.IntegerEditor;
        StoneWeight: WeightEditor;
        OtherPieces: Serenity.IntegerEditor;
        OtherWeight: WeightEditor;
        MetalAmount: Serenity.DecimalEditor;
        DiamondAmount: Serenity.DecimalEditor;
        OtherAmount: Serenity.DecimalEditor;
        CalcOnId: Serenity.IntegerEditor;
        UnitCost: Serenity.DecimalEditor;
        Discount: Serenity.DecimalEditor;
        WstPer: Serenity.DecimalEditor;
        WstWt: Serenity.DecimalEditor;
        CostMethodId: Serenity.LookupEditor;
        RefTransItemId: Serenity.StringEditor;
        RefTransId: Serenity.StringEditor;
        Remark: Serenity.StringEditor;
        SpecialRemark: Serenity.StringEditor;
        UserDescription: Serenity.StringEditor;
        AckStatus: Serenity.IntegerEditor;
        DeliveryDate: Serenity.DateEditor;
        CompanyId: Serenity.IntegerEditor;
        BagStatus: Serenity.StringEditor;
        ImageName: Serenity.ImageUploadEditor;
    }

    export class LotCreationItemsForm extends Serenity.PrefixedContext {
        static formKey = 'Inventory.LotCreationItems';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!LotCreationItemsForm.init)  {
                LotCreationItemsForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;
                var w1 = s.StringEditor;
                var w2 = s.LookupEditor;
                var w3 = CommonCategoryLookup;
                var w4 = CommonSubCategoryLookup;
                var w5 = WeightEditor;
                var w6 = s.DecimalEditor;
                var w7 = AmountEditor;
                var w8 = s.BooleanEditor;
                var w9 = s.DateEditor;
                var w10 = s.ImageUploadEditor;

                Q.initFormType(LotCreationItemsForm, [
                    'PartyId', w0,
                    'TransItemId', w1,
                    'BagNo', w1,
                    'SKU', w1,
                    'LotNo', w1,
                    'CertificateNo', w1,
                    'RefNo', w1,
                    'ItemTypeId', w0,
                    'ProductId', w1,
                    'DesignId', w1,
                    'ProductCode', w1,
                    'ProductName', w1,
                    'DesignCode', w1,
                    'AttributeId', w1,
                    'ProductTypeId', w2,
                    'CategoryId', w3,
                    'SubCategoryId', w4,
                    'BrandId', w2,
                    'SuperTypeId', w2,
                    'CollectionId', w2,
                    'Pieces', w0,
                    'Weight', w5,
                    'UnitRate', w6,
                    'StoneRate', w7,
                    'OtherRate', w7,
                    'UnitLabour', w6,
                    'FancyCharges', w7,
                    'OtherCharges', w7,
                    'StoneAmount', w6,
                    'NetAmount', w6,
                    'GrossAmount', w6,
                    'CCNetAmount', w6,
                    'CCGrossAmount', w6,
                    'HasBom', w8,
                    'Line_No', w1,
                    'HSN', w2,
                    'NetWeight', w5,
                    'DiamondPieces', w0,
                    'DiamondWeight', w5,
                    'StonePieces', w0,
                    'StoneWeight', w5,
                    'OtherPieces', w0,
                    'OtherWeight', w5,
                    'MetalAmount', w6,
                    'DiamondAmount', w6,
                    'OtherAmount', w6,
                    'CalcOnId', w0,
                    'UnitCost', w6,
                    'Discount', w6,
                    'WstPer', w6,
                    'WstWt', w6,
                    'CostMethodId', w2,
                    'RefTransItemId', w1,
                    'RefTransId', w1,
                    'Remark', w1,
                    'SpecialRemark', w1,
                    'UserDescription', w1,
                    'AckStatus', w0,
                    'DeliveryDate', w9,
                    'CompanyId', w0,
                    'BagStatus', w1,
                    'ImageName', w10
                ]);
            }
        }
    }
}
